const FEATURES = [
  {
    icon: 'ri-shield-check-line',
    title: 'Enterprise-Grade Security',
    description:
      'Our VPN employs AES-256 encryption, the same standard used by governments and financial institutions, ensuring your data is always protected.',
  },
  {
    icon: 'ri-speed-line',
    title: 'Blazing Performance',
    description:
      'Optimized network protocols and intelligent routing deliver fast, stable connections without compromising on security or privacy.',
  },
  {
    icon: 'ri-smartphone-line',
    title: 'iOS-Native Design',
    description:
      'Built exclusively for iOS, our apps integrate seamlessly with Apple\'s ecosystem — respecting system guidelines and delivering a native feel.',
  },
  {
    icon: 'ri-eye-off-line',
    title: 'Zero-Log Privacy',
    description:
      'We never store, track, or sell your data. Our strict no-log policy means your browsing history stays yours — always.',
  },
  {
    icon: 'ri-cpu-line',
    title: 'Smart Optimization',
    description:
      'NEDZA Cleaner uses intelligent algorithms to identify and remove only unnecessary files, keeping your important data safe while freeing up space.',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Dedicated Support',
    description:
      'Our expert support team is available to help you get the most out of every product, with fast response times and thorough solutions.',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-28 md:py-36 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-emerald-600 border border-emerald-200 rounded-full px-4 py-1.5 bg-emerald-50 mb-5">
            Capabilities
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-5">
            What Makes Us Different
          </h2>
          <p className="text-gray-500 text-base md:text-lg max-w-xl mx-auto leading-relaxed">
            Specialized expertise in mobile security and performance optimization — built into every product we ship.
          </p>
        </div>

        {/* Feature Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {FEATURES.map((feature) => (
            <div
              key={feature.title}
              className="bg-white rounded-2xl p-7 md:p-8 group hover:bg-emerald-600 transition-all duration-300 cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gray-100 group-hover:bg-white/20 transition-colors duration-300 mb-6">
                <i className={`${feature.icon} text-emerald-600 group-hover:text-white text-xl transition-colors duration-300`}></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900 group-hover:text-white mb-3 transition-colors duration-300">
                {feature.title}
              </h4>
              <p className="text-gray-500 group-hover:text-emerald-100 text-sm leading-relaxed transition-colors duration-300">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
